import { ApiFollowUpService } from './api-followUp.service';
import { useLocalSession } from 'auth/helpers/session.hooks';
import {
    ChargeDecisionInputDto,
    ChargeDecisionResponseDto,
    CompleteFollowUpDto,
    PaginationDto,
    priceDto,
    UpdatePriceResponseDto,
} from 'services/followUps/followUp.dto';

export interface FollowUpService {
    getAllFollowUps(input?: { offset: number; limit: number }): Promise<PaginationDto<CompleteFollowUpDto>>;
    updatePrice(input: priceDto): Promise<UpdatePriceResponseDto>;
    applyFilters(inputQuery: any): Promise<PaginationDto<CompleteFollowUpDto>>;
    updateCharge(body: { charge: boolean }, id: number): Promise<CompleteFollowUpDto>;
    applyChargeDecision(id: number, input: ChargeDecisionInputDto): Promise<ChargeDecisionResponseDto>;
}

export const useApiFollowUpService = (): FollowUpService => {
    const [getSession] = useLocalSession();
    const session = getSession();
    return new ApiFollowUpService(session);
};
